import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Checkbox, Form, Button } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { isNilOrEmpty } from 'utils/helpers';
import { GroupHeader, ExpandButtonWrapper, OptionsWrapper, NestedOptionsWrapper } from './styled';
var GroupSelect = function (_a) {
    var _b;
    var form = _a.form, group = _a.group;
    var _c = useState(false), expanded = _c[0], setExpanded = _c[1];
    if (isNilOrEmpty(group.items))
        return null;
    var flatOptions = ((_b = group === null || group === void 0 ? void 0 : group.items) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({ label: item.display_name, value: item.id }); })) || [];
    var flatOptionIds = flatOptions.map(function (option) { return option.value; });
    var groupValues = Form.useWatch(group.id, { form: form, preserve: true });
    // Excludes archived items
    var activeGroupValues = (groupValues === null || groupValues === void 0 ? void 0 : groupValues.filter(function (id) { return flatOptionIds.includes(id); })) || [];
    var handleGroupChange = function (checked) {
        if (checked)
            return form.setFieldValue(group.id, undefined);
        return form.setFieldValue(group.id, flatOptionIds);
    };
    var isGroupPartiallySelected = activeGroupValues.length > 0 && activeGroupValues.length < flatOptionIds.length;
    var isGroupFullySelected = activeGroupValues.length === flatOptionIds.length;
    return (_jsxs(OptionsWrapper, { children: [_jsxs(GroupHeader, { children: [_jsx(ExpandButtonWrapper, { children: _jsx(Button, { type: "text", size: "small", icon: expanded ? _jsx(DownOutlined, {}) : _jsx(UpOutlined, {}), onClick: function () { return setExpanded(!expanded); } }) }), _jsx(Checkbox, { checked: isGroupFullySelected, indeterminate: isGroupPartiallySelected, onChange: function () { return handleGroupChange(isGroupFullySelected); }, children: group.display_name })] }), _jsx(NestedOptionsWrapper, { children: _jsx(Form.Item, { name: group.id, noStyle: true, hidden: !expanded, children: _jsx(Checkbox.Group, { options: flatOptions, style: { display: 'flex', flexDirection: 'column' } }) }) })] }));
};
export default GroupSelect;
